/**
 * 关键词排名
 */
const member = () => import(/* webpackChunkName: "group-member" */ '../view/member/member.vue');
export default [
    {
        path: '/member',
        name: 'member',
        component: member,
        meta: {
            title: '【旋涡营销】'
        }
    },
]



// WEBPACK FOOTER //
// ./app/router/router-member.js